import * as React from "react";

const { Component } = React;

import { alert } from "../general/alertStore";
import { Integration } from "./Integrations";

import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";

import axios from "../general/HttpClient";

interface IntegrationTriggerProps {
    integration: Integration;
}

interface IntegrationTriggerState {
    integration: Integration;
}

export default class IntegrationTrigger extends Component<IntegrationTriggerProps, IntegrationTriggerState> {
    constructor(props) {
        super(props);
        this.state = {
            integration: props.integration,
        };
    }

    static getDerivedStateFromProps = (nextProps) => {
        if (nextProps.integration) {
            return { integration: nextProps.integration };
        }
    };

    componentDidMount() {}

    enableTrigger = () => {
        axios.post(`/api/Integrations/${this.state.integration.integrationId}/Trigger`, {}).then((response) => {
            this.setState({ integration: response.data });
        });
    };

    disableTrigger = () => {
        axios.delete(`/api/Integrations/${this.state.integration.integrationId}/Trigger`).then((response) => {
            this.setState({ integration: response.data });
        });
    };

    testTrigger = () => {
        axios.post(`/api/Integrations/Trigger/${this.state.integration.triggerId}/$run`, {}).then((response) => {
            alert({
                type: "alert-info",
                text: response.data,
            });
        });
    };

    render() {
        return (
            <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Trigger ID</label>
                        <p className="text-sm text-gray-600">{this.state.integration.triggerId || "--"}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Trigger Last Run</label>
                        <p className="text-sm text-gray-600">{this.state.integration.triggerLastRun || "Never"}</p>
                    </div>
                </div>
                {PermissionStore.CheckCurrentUserHasPermission("executeTriggers") && (
                    <div className="flex justify-end space-x-2">
                        {this.state.integration.triggerEnabled && (
                            <button className="px-4 py-2 bg-yellow-600 text-white text-sm font-medium rounded-md hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors" onClick={this.disableTrigger}>
                                Disable Trigger
                            </button>
                        )}
                        {!this.state.integration.triggerEnabled && (
                            <button className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" onClick={this.enableTrigger}>
                                Enable Trigger
                            </button>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
